import Vue from "vue";
import Vuex from "vuex";
import router from "../../router"
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const VUE_APP_URL = process.env.VUE_APP_URL;
const VUE_APP_API = process.env.VUE_APP_API;

const vuexPersist = new VuexPersistence({
    storage: sessionStorage,
    reducer: (state) => ({ authToken: state.authToken, username: state.username, admin: state.admin })
});

export default new Vuex.Store({
    state: {
        prototypeArray: [],
        prototype: {
            title: "",
            path: "",
            update: "",
            deployed: "",
            deploys: []
        },
        authToken: "",
        username: "",
        admin: "",
        loginUsername: "",
        loginPw: "",
        file: "",
        totalWidth: 0,
        VUE_APP_URL: VUE_APP_URL,
        config: {
            nginx: null
        }
    },
    plugins: [vuexPersist.plugin],
    getters: {
        prototypeArray: state => {
            return state.prototypeArray;
        },
        prototype: state => {
            return state.prototype;
        },
        file: state => {
            return state.file;
        },
        deployed: state => {
            return state.prototype.deployed;
        },
        deploys: state => {
            return state.prototype.deploys;
        },
        totalWidth: state => {
            return state.totalWidth;
        },
        authToken: state => {
            return state.authToken;
        },
        username: state => {
            return state.username;
        },
        admin: state => {
            return state.admin;
        },
        loginUsername: state => {
            return state.loginUsername;
        },
        loginPw: state => {
            return state.loginPw;
        },
        VUE_APP_URL: state => {
            return state.VUE_APP_URL;
        }
    },
    mutations: {
        prototypeArrayUpdate(state, newPrototypeArray){
            state.prototypeArray = newPrototypeArray;
        },
        prototypeUpdate(state, newPrototype){
            state.prototype = newPrototype;
        },
        pathUpdate(state, newPath){
            Vue.set(state.prototype, 'path', newPath);
        },
        titleUpdate(state, newTitle){
            Vue.set(state.prototype, 'title', newTitle);
        },
        fileUpdate(state, newFile){
            state.file = newFile;
        },
        updateUpdate(state, newUpdate){
            Vue.set(state.prototype, 'update', newUpdate);
        },
        deployedUpdate(state, newDeployed){
            Vue.set(state.prototype, "deployed", newDeployed);
        },
        totalWidthUpdate(state, newTotalWidth){
            state.totalWidth = newTotalWidth;
        },
        authTokenUpdate(state, newAuthToken){
            state.authToken = newAuthToken;
        },
        usernameUpdate(state, newUsername){
            state.username = newUsername;
        },
        adminUpdate(state, newAdmin){
            state.admin = newAdmin;
        },
        loginUsernameUpdate(state, newLoginUsername){
            state.loginUsername = newLoginUsername;
        },
        loginPwUpdate(state, newLoginPw){
            state.loginPw = newLoginPw;
        }
    },
    actions: {
        clearPrototype({ commit }) {
            let clearData = this.state.prototype;
            for (let i = 0; i < Object.keys(clearData).length; i++) {
                let property = Object.keys(clearData)[i];
                clearData[property] = "";
            }
            commit("prototypeUpdate", clearData);
            commit("fileUpdate", "");
        },

        populatePrototype: (context, path) => {
            return new Promise ((resolve, reject) => {
                Vue.axios
                    .get(VUE_APP_API + "/prototypes/" + path, { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        context.commit("prototypeUpdate", response.data);
                        context.commit("fileUpdate", "");
                        resolve(response);
                    })
                    .catch(error => {
                        window.alert("Unable to find project. " + error);
                        router.push("/");
                        reject(error);
                    })
            })
        },

        populateHomePage: (context) => {
            return new Promise((resolve, reject) => {
                Vue.axios
                    .get(VUE_APP_API + "/prototypes/all", { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        context.commit("prototypeArrayUpdate", response.data);
                        context.commit("fileUpdate", "");
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },

        deletePrototype: (context, path) => {
            return new Promise((resolve, reject) => {
                Vue.axios
                    .delete(VUE_APP_API + "/prototypes/delete/" + path, { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },

        // eslint-disable-next-line no-unused-vars
        createPrototype: (context) => {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append("title", context.state.prototype.title);
                formData.append("path", context.state.prototype.path);
                formData.append('update', context.state.prototype.update);
                formData.append("prototypeFile", context.state.file);
                Vue.axios
                    .post(VUE_APP_API + "/prototypes/new",
                        formData, { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },

        deleteDeploy: (context, filepath) => {
            return new Promise((resolve, reject) => {
                Vue.axios
                    .delete(VUE_APP_API + "/prototypes/delete/" + filepath, { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },

        createDeploy: (context, path) => {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append("path", path);
                formData.append('update', context.state.prototype.update);
                formData.append("prototypeFile", context.state.file);
                Vue.axios
                    .post(VUE_APP_API + "/prototypes/edit/deploy/new",
                        formData, { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },

        renamePrototype: (context, path) => {
            return new Promise((resolve, reject) => {
                let data = {
                    title: context.state.prototype.title,
                    path: context.state.prototype.path,
                    update: context.state.prototype.update
                };
                Vue.axios
                    .put(VUE_APP_API + "/prototypes/edit/" + path, data,
                        { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },

        redeployPrototype: (context, filepath) => {
            return new Promise((resolve, reject) => {
                let data = {
                    update: context.state.prototype.update
                };
                Vue.axios
                    .put(VUE_APP_API + "/prototypes/edit/deploy/" + filepath, data,
                        { headers: {Authorization: context.state.authToken}})
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },

        newUser: (context, role) => {
            return new Promise((resolve, reject) => {
                let data = {
                    username: context.state.loginUsername,
                    pw: context.state.loginPw
                };
                Vue.axios
                    .post(VUE_APP_API + '/prototypes/new/' + role, data)
                    .then(response => {
                        window.alert("User created successfully.");
                        context.commit("loginUsernameUpdate", "");
                        context.commit("loginPwUpdate", "");
                        resolve(response);
                    })
                    .catch(err => {
                        // eslint-disable-next-line no-console
                        window.alert("Operation failed. " + err.response.data);
                        reject(err);
                    })
            })
        },

        login: ({commit}, userInfo) => {
            return new Promise((resolve, reject) => {
                let data = {
                    username: userInfo.loginUsername,
                    pw: userInfo.loginPw
                };
                Vue.axios
                    .put(VUE_APP_API + '/prototypes/login', data)
                    .then(response => {
                        commit("authTokenUpdate", response.data.token);
                        commit("usernameUpdate", response.data.username);
                        commit("adminUpdate", response.data.admin);
                        resolve(response);
                    })
                    .catch(err => {
                        window.alert("Unsuccessful login. " + err);
                        reject(err);
                    })
            })
        },

        synchronizeDatabase: (context) => {
            return new Promise((resolve, reject) => {
                let data = {};
                Vue.axios
                    .put(VUE_APP_API + "/prototypes/sync", data, { headers: {Authorization: context.state.authToken}})
                        .then(response => {
                            window.alert(response.data)
                            resolve(response);
                        })
                        .catch(error => {
                            window.alert("Synchronize unsuccessful. " + error.response.data);
                            reject(error);
                        })
            })
        }
    },
});
